<template>
  <div>
    <div v-show="!showResult">
      <div class="white-box-border">
        <h2 class="white-box-title">자가진단</h2>
        <div class="notice-wrapper">
          <div class="post-content">
            <p>본 검사는 삶의 전반적인 영역을 종합적으로 확인해 봄으로써 성공적인 제 2 인생설계에 도움을 드리고자 개발되었습니다.  검사를 통해  보람 있고 균형 잡힌  제 2의 삶을 설계하는 데  필요한 여러 가지 기본적인 정보들을 얻으실 수 있을 것입니다.</p>
            <p><strong>본 검사 문항에는 ‘맞는 답’과 ‘틀린 답’이 없습니다.</strong></p>
            <p>정확한 진단과 올바른 처방을 위해 자기 자신의 상태와 생각을 솔직하게 응답해 주시기 바랍니다.  또한 검사 시간에 제한은 없으나 각각의 문항에 대해 너무 오래 생각하지 마시고 떠오르는 대로 바로 바로 답해 주시기  바랍니다.</p>
          </div>
        </div>
      </div>
      <div class="diagnosis-process-wrapper" id="buttons-tab">
        <ul class="btn-tabs clearfix gutter-10">
          <li :class="`btn-tab f-gutter-8__li ${tabIndex === 0 ? 'active' : ''}`" v-for="(tab, tabIndex) in tabs" :id="`tabListId${tabIndex}`" >
            <button class="btn-tab__link" @click="tabClick(tab.num, tab.num)">자가진단-{{tab.name}}</button>
          </li>
        </ul>
      </div>
      <h2>{{stepTitleNo == 0 ? '재무' : stepTitleNo == 1 ? '건강' : stepTitleNo == 2 ? '가족' : stepTitleNo == 3 ? '사회적 관계' : stepTitleNo == 4 ? '여가' : stepTitleNo == 5 ? '일과 자기계발' : stepTitleNo == 6 ? '사회공헌' : '결과'}} 설문입력</h2>
      <div class="btn-tab-content tab-content">
        <div v-for="(tab, tabIndex) in tabs" :class="`btn-tab-pane tab-pane ${tab.num == 0 ? 'active' : ''}`" :id="`tabList${tab.num}`" >
          <div class="radio-value-label-group" :id="`radio-value-label-group--${tabIndex}`">
            <div class="radio-value-label">
              <div class="radio-value-label__text">
                <label class="radio-text-label radio-text-label--much">매우<br>그렇다</label>
                <label class="radio-text-label"><i class="fa fa-arrow-left"></i></label>
                <label class="radio-text-label radio-text-label--middle">보통</label>
                <label class="radio-text-label"><i class="fa fa-arrow-right"></i></label>
                <label class="radio-text-label radio-text-label--not">전혀<br>아니다</label>
              </div>
              <div class="radio-value-label__number">
                <label class="radio-number-label">5</label>
                <label class="radio-number-label">4</label>
                <label class="radio-number-label">3</label>
                <label class="radio-number-label">2</label>
                <label class="radio-number-label">1</label>
              </div>
            </div>
          </div>
          <div class="diagnosis-box">
            <div class="top-decor-gb-group" :id="`top-decor-gb-group-${tabIndex}`">
              <div class="top-blue-bg"></div>
              <div class="top-light-blue-bg"></div>
            </div>
            <div class="check-answering" :id="`session-btn-${tabIndex}`">
              <button class="session-btn" @click="doAnswer(tabIndex)" :id="`writebtn${tabIndex}`">{{tab.name}} 설문 작성하기</button>
            </div>
            <ul :class="`diagnosis-box-ul diagnosis-box-ul--${tabIndex}`">
              <li v-show="!showFinish" v-for="(qGroup, gindex) in tab.qGroups">
                <h3 :class="`category-label-title category-label-title--${gindex}`">{{tab.name}} - {{qGroup.label}}</h3>
                <ul>
                  <li class="self-diagnosis-question" v-for="(question, index) in qGroup.questions">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">{{index+1}}. {{question.text}}</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" :name="`diagosis${qGroup.startNo + index}`" @click="answering((qGroup.startNo + index), 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" :name="`diagosis${qGroup.startNo + index}`" @click="answering((qGroup.startNo + index), 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" :name="`diagosis${qGroup.startNo + index}`" @click="answering((qGroup.startNo + index), 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" :name="`diagosis${qGroup.startNo + index}`" @click="answering((qGroup.startNo + index), 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" :name="`diagosis${qGroup.startNo + index}`" @click="answering((qGroup.startNo + index), 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="diagnosis-submit-btns">
              <button class="diagnosis-submit__btn btn--blue-line" v-if="tab.num < 6" @click="tabClick(tab.num, tab.num+1)">다음 영역 진단하기</button>
              <button class="diagnosis-submit__btn btn--blue-line" @click="tabClick(tab.num, 7)">완료 후 결과보기</button>
            </div>
          </div>
        </div>
        <div class="tab-pane active" v-show="showFinish">
          <div class="radio-value-label-group" id="radio-value-label-group--7">
            <div class="radio-value-label">
              <div class="radio-value-label__text">
                <label class="radio-text-label radio-text-label--much">매우<br>그렇다</label>
                <label class="radio-text-label"><i class="fa fa-arrow-left"></i></label>
                <label class="radio-text-label radio-text-label--middle">보통</label>
                <label class="radio-text-label"><i class="fa fa-arrow-right"></i></label>
                <label class="radio-text-label radio-text-label--not">전혀<br>아니다</label>
              </div>
              <div class="radio-value-label__number">
                <label class="radio-number-label">5</label>
                <label class="radio-number-label">4</label>
                <label class="radio-number-label">3</label>
                <label class="radio-number-label">2</label>
                <label class="radio-number-label">1</label>
              </div>
            </div>
          </div>
          <div class="diagnosis-box">
            <div class="top-decor-gb-group" id="top-decor-gb-group-7">
              <div class="top-blue-bg"></div>
              <div class="top-light-blue-bg"></div>
            </div>
            <ul class="diagnosis-box-ul diagnosis-box-ul--7">
              <li>
                <h3 class="category-label-title category-label-title--0">심리 및 정서</h3>
                <ul>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">나는 현재 행복하다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis84" @click="answering(84, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis84" @click="answering(84, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis84" @click="answering(84, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis84" @click="answering(84, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis84" @click="answering(84, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">나는 퇴직, 노화와 같은 중대한 변화에도 긍정적으로 대처할 수 있다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis85" @click="answering(85, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis85" @click="answering(85, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis85" @click="answering(85, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis85" @click="answering(85, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis85" @click="answering(85, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">나의 앞날은 여전히 긍정적이고 밝다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis86" @click="answering(86, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis86" @click="answering(86, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis86" @click="answering(86, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis86" @click="answering(86, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis86" @click="answering(86, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">현재의 생활방식에 만족한다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis87" @click="answering(87, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis87" @click="answering(87, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis87" @click="answering(87, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis87" @click="answering(87, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis87" @click="answering(87, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">나는 스스로의 감정을 잘 조절할 수 있다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis88" @click="answering(88, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis88" @click="answering(88, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis88" @click="answering(88, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis88" @click="answering(88, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis88" @click="answering(88, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">대체로 나 자신에 대해 만족한다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis89" @click="answering(89, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis89" @click="answering(89, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis89" @click="answering(89, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis89" @click="answering(89, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis89" @click="answering(89, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
                <h3 class="category-label-title">자기이해</h3>
                <ul>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">나는 나 자신을 있는 그대로 받아들일 수 있다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis90" @click="answering(90, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis90" @click="answering(90, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis90" @click="answering(90, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis90" @click="answering(90, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis90" @click="answering(90, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">나의 장점과 단점에 대해서 알고 있다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis91" @click="answering(91, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis91" @click="answering(91, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis91" @click="answering(91, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis91" @click="answering(91, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis91" @click="answering(91, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                  <li class="self-diagnosis-question">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">내가 가장 원하는 것이 무엇인지 알고 있다.</label>
                      <div class="self-diagnosis-radios">
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis92" @click="answering(92, 5)" :value="5" title="5 선택"><span class="self-radio-text">5</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis92" @click="answering(92, 4)" :value="4" title="4 선택"><span class="self-radio-text">4</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis92" @click="answering(92, 3)" :value="3" title="3 선택"><span class="self-radio-text">3</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis92" @click="answering(92, 2)" :value="2" title="2 선택"><span class="self-radio-text">2</span>
                        </label>
                        <label class="radio-inline label__radio">
                          <input type="radio" name="diagosis92" @click="answering(92, 1)" :value="1" title="1 선택"><span class="self-radio-text">1</span>
                        </label>
                      </div>
                    </div>
                  </li>
                </ul>
                <h3 class="category-label-title">기본</h3>
                <ul>
                  <li class="">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">귀하의 성별은 어떻게 되십니까?</label>
                      <label for="M" class="radio-inline label__radio" @click="answerGender('M')">
                        <input id="M" type="radio" name="gender" value="M" title="남자 선택"> 남자
                      </label>
                      <label for="F" class="radio-inline label__radio" @click="answerGender('F')">
                        <input id="F" type="radio" name="gender" value="F" title="여자 선택"> 여자
                      </label>
                    </div>
                  </li>
                  <li class="">
                    <div class="block-input-group clearfix">
                      <label for="age" class="block-input-label">귀하의 연령은 어떻게 되십니까?</label>
                      만 <input type="number" v-model="age" id="age" class="input__text input__text--sm" v-on:change="answerAge" placeholder="" title="세 입력"> 세
                    </div>
                  </li>
                  <li class="">
                    <div class="block-input-group clearfix">
                      <label class="block-input-label">현재 고용상태는 어떻게 되십니까?</label>
                      <label for="job_fullTime" class="radio-inline label__radio" @click="answerJob('정규직')">
                        <input id="job_fullTime" type="radio" name="job" value="정규직" title="정규직 선택"> 정규직
                      </label>
                      <label for="job_temporary" class="radio-inline label__radio" @click="answerJob('임시직')">
                        <input id="job_temporary" type="radio" name="job" value="임시직" title="임시직 선택"> 임시직
                      </label>
                      <label for="job_selfEmployment" class="radio-inline label__radio" @click="answerJob('자영업')">
                        <input id="job_selfEmployment" type="radio" name="job" value="자영업" title="자영업 선택"> 자영업
                      </label>
                      <label for="job_leave" class="radio-inline label__radio" @click="answerJob('휴직상태(구직중)')">
                        <input id="job_leave" type="radio" name="job" value="휴직상태(구직중)" title="휴직상태(구직중) 선택"> 휴직상태(구직중)
                      </label>
                      <label for="job_retirement" class="radio-inline label__radio" @click="answerJob('은퇴')">
                        <input id="job_retirement" type="radio" name="job" value="은퇴" title="은퇴 선택"> 은퇴
                      </label>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <div class="diagnosis-submit-btns">
              <button class="diagnosis-submit__btn btn--blue-line" @click="submitAnswers">결과보기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showResult">
      <div class="white-box-border">
        <h2 class="white-box-title">자가진단 결과</h2>
        <div class="self-diagnosis-result" v-for="(result, resultIndex) in calculResult">
          <h3 class="part-title">{{result[1]}}</h3>
          <p class="self-diagnosis-result-p"><span class="result-p-accent">현재상태</span>의 평균값은 <span :class="`result-grade result-grade--${gradeClass(result[4])}`">{{result[3]}}</span>점으로 여타 평균과 비교하여<br class="visible-xs"> <span :class="`result-label result-label--${gradeClass(result[4])}`">{{result[4]}}&nbsp;&nbsp;<i :class="`fa ${arrowClass(result[4])}`"></i></span> 나타났습니다.</p>
          <p class="self-diagnosis-result-p"><span class="result-p-accent">미래준비도</span>의 평균값은 <span :class="`result-grade result-grade--${gradeClass(result[7])}`">{{result[6]}}</span>점으로 여타 평균과 비교하여<br class="visible-xs"> <span :class="`result-label result-label--${gradeClass(result[7])}`">{{result[7]}}&nbsp;&nbsp;<i :class="`fa ${arrowClass(result[7])}`"></i></span> 나타났습니다.</p>
          <p class="self-diagnosis-result-p"><span class="result-p-accent">욕구 및 희망</span>의 평균값은 <span :class="`result-grade result-grade--${gradeClass(result[10])}`">{{result[9]}}</span>점으로 여타 평균과 비교하여<br class="visible-xs"> <span :class="`result-label result-label--${gradeClass(result[10])}`">{{result[10]}}&nbsp;&nbsp;<i :class="`fa ${arrowClass(result[10])}`"></i></span> 나타났습니다.</p>
        </div>
        <div class="self-diagnosis-result">
          <div class="info-box--icon">
            <div class="info-box-icon">안내 <i class="fa fa-info-circle"></i></div>
            <p class="info-box--icon__p">위 생애설계 종합진단은 7대영역의 미래준비도, 욕구 및 희망과 현재상태를 진단한 결과입니다.<br>
            이 영역들에 대한 관심을 갖고 미래를 준비하시기를 권합니다. </p>
          </div>
        </div>
        <div class="self-diagnosis-result">
          <div class="post-content">
            <p>위 생애설계 종합진단은 7대영역의 미래준비도, 욕구 및 희망과 현재상태를 진단한 결과 입니다. 이영역들에 대한 관심을 갖고 미래를 준비하시기를 권합니다. </p>
            <p>서울시 50플러스에서는 컨설턴트가 생애설계 7대영역에 대한 1:1상담을 무료로 진행하고 있으며,<br>
            50+세대들의 관심이나 선호, 경험, 조건에 따라 선택하도록 </p>
            <p><span class="blue"><strong>인생재설계학부, 커리어모색학부, 일상기술학부</strong></span> 세 개의 학부로 구성된 교육프로그램을 학기별로 진행하고 있습니다.<br>
            이 기회를 활용하시어 보다 나은 제2의 인생을 설계하시기를 바랍니다.</p>
            </p>
          </div>
        </div>

        <div class="diagnosis-submit-btns">
          <a href="counsel.do" class="diagnosis-submit__btn btn--blue">상담 신청하기</a>
          <a href="education.do" class="diagnosis-submit__btn btn--blue" >배움 바로가기</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'self-diagnosis',
    data() {
      return {
        answer: {},
        calculResult: [],
        age: null,
        gender: null,
        job: null,
        checkingSteps: [],
        currentTab: '',
        processing: false,
        currentTabChecking: false,
        showFinish: false,
        showResult: false,
        checkingTab1: false,
        checkingTab2: false,
        checkingTab3: false,
        checkingTab4: false,
        checkingTab5: false,
        checkingTab6: false,
        checkingTab7: false,
        stepTitleNo: '',
        tabs: [
          {
            num: 0,
            name: '재무',
            qGroups: [
              {
                label: '현재상태',
                average: 3.26,
                stdev: 0.82,
                maxV: 5.00,
                minV: 1.00,
                startNo: 0,
                questions: [
                  {
                    text: '나는 향후 상당기간(예를 들어 예상되는 은퇴시점까지 또는 어느 정도 노후준비가 이루어 질 때까지) 안정적인 소득이 가능하다.',
                  },
                  {
                    text: '현재 소득대비 지출규모는 적당하다.',
                  },
                  {
                    text: '현재의 주거상황(자기주택, 전세 등)은 안정적이며, 재무적으로 큰 부담을 주지 않는다.',
                  },
                  {
                    text: '현재 부채는 나의 자산과 소득규모를 고려할 때 적절한 수준이다.',
                  },
                ],
              },
              {
                label: '미래준비도',
                average: 3.14,
                stdev: 0.8,
                maxV: 5.00,
                minV: 1.00,
                startNo: 4,
                questions: [
                  {
                    text: '재무 및 자산관리 관련 지식(투자, 자산관리, 세무, 은퇴 후 재무계획, 각종 연금관련 지식 등)을 보유하기 위해 노력하고 있다.',
                  },
                  {
                    text: '미래 및 노후 대비를 위한 재무 계획을 수립해 놓고 있다.',
                  },
                  {
                    text: '은퇴 후를 대비한 재무 계획에 따라 수입, 지출, 자산 관리(저축, 투자, 연금 등)가 이루어지고 있다.',
                  },
                  {
                    text: '자녀 결혼 등 목돈지출에 대해 계획적으로 준비하고 있다.',
                  },
                  {
                    text: '노후의 주거대책이 계획대로 준비되고 있다.',
                  },
                ],
              },
              {
                label: '욕구 및 희망',
                average: 3.97,
                stdev: 0.7,
                maxV: 5.00,
                minV: 1.00,
                startNo: 9,
                questions: [
                  {
                    text: '나는 앞으로 보다 안정적이거나, 보다 많은 소득을 얻길 원한다.',
                  },
                  {
                    text: '나는 앞으로 규모 있는 지출과 부채 관리로 보다 건전한 재무상태를 만들어 나가고 싶다.',
                  },
                  {
                    text: '향후 재무적 안정은 앞으로의 내 삶에 있어서 매우 중요한 부분이다.',
                  },
                  {
                    text: '왜 돈을 모으고 싶은지에 대한 구체적이고 명확한 이유를 가지고 있다.(예를 들어 안정된 노후, 자유로운 취미생활, 기부와 나눔 등).',
                  },
                ],
              },
            ],
          },
          {
            num: 1,
            name: '건강',
            qGroups: [
              {
                label: '현재상태',
                average: 3.97,
                stdev: 0.75,
                maxV: 5.00,
                minV: 1.5,
                startNo: 13,
                questions: [
                  {
                    text: '나는 현재 건강에 좋은 식사습관을 가지고 있다.',
                  },
                  {
                    text: '나는 현재 바람직한 생활습관을 가지고 있다.(적당한 음주, 금연, 규칙적인 운동, 적당한 수면 등)',
                  },
                  {
                    text: '나의 전반적인 건강상태는 양호하다.',
                  },
                  {
                    text: '나는 건강관리 방법을 잘 알고 있다.',
                  },
                ],
              },
              {
                label: '미래준비도',
                average: 3.86,
                stdev: 0.68,
                maxV: 5.00,
                minV: 2.00,
                startNo: 17,
                questions: [
                  {
                    text: '나는 건강과 관련된 정보획득활동을 위해 노력하고 있다.(건강관련 서적/뉴스/영상물 참조, 건강강좌 참석 등)',
                  },
                  {
                    text: '나는 미래의 건강을 위하여 정기적인 건강 검진을 받고 있다.',
                  },
                  {
                    text: '앞으로 건강을 유지하기 위한 바람직한 식사습관에 관심을 갖고 실천하려 하고 있다.',
                  },
                  {
                    text: '앞으로 건강을 유지하기 위한 바람직한 생활습관에 관심을 갖고 실천하려 하고 있다.(적당한 음주, 금연, 규칙적인 운동, 적당한 수면 등)',
                  },
                ],
              },
              {
                label: '욕구 및 희망',
                average: 4.29,
                stdev: 0.61,
                maxV: 5.00,
                minV: 2.2,
                startNo: 21,
                questions: [
                  {
                    text: '향후 지속적으로 건강을 유지하는 것은 앞으로의 내 삶에 있어서 매우 중요한 부분이다.',
                  },
                  {
                    text: '나는 지금보다 더 건강해지고 싶다.',
                  },
                  {
                    text: '나는 앞으로도 건강에 좋은 식습관을 가지고 싶다.',
                  },
                  {
                    text: '나는 앞으로도 건강증진을 위한 생활습관을 가지고 싶다. (금주, 금연, 운동, 수면 등)',
                  },
                  {
                    text: '앞으로 건강을 위한 상담 또는 강좌나 세미나가 열린다면 참여하고 싶다.',
                  },
                ],
              },
            ],
          },
          {
            num: 2,
            name: '가족',
            qGroups: [
              {
                label: '현재상태',
                average: 3.8,
                stdev: 0.8,
                maxV: 5.00,
                minV: 1,
                startNo: 26,
                questions: [
                  {
                    text: '나는 배우자와 좋은 관계를 유지하고 있다.',
                  },
                  {
                    text: '배우자와 수시로 솔직하고 진솔한 대화를 나눈다.',
                  },
                  {
                    text: '나는 가족들과 많은 시간을 보내고 있다.',
                  },
                  {
                    text: '가족들은 나를 믿고 지지해 준다.',
                  },
                ],
              },
              {
                label: '미래준비도',
                average: 3.92,
                stdev: 0.75,
                maxV: 5.00,
                minV: 1.00,
                startNo: 30,
                questions: [
                  {
                    text: '나는 배우자와 좋은 관계를 형성하는 방법을 찾기 위해 노력하고 있다.',
                  },
                  {
                    text: '나는 배우자와 좋은 관계를 유지하기 위해 노력하고 있다.',
                  },
                  {
                    text: '나는 가족들과 좋은 관계를 형성하는 방법을 찾기 위해 노력하고 있다.',
                  },
                  {
                    text: '나는 가족들과 좋은 관계를 유지하기 위해 노력하고 있다.',
                  },
                ],
              },
              {
                label: '욕구 및 희망',
                average: 4.29,
                stdev: 0.61,
                maxV: 5.00,
                minV: 1,
                startNo: 34,
                questions: [
                  {
                    text: '나는 앞으로도 배우자와 계속 좋은 관계를 형성하고 싶다.',
                  },
                  {
                    text: '나는 앞으로도 가족들과 계속 좋은 관계를 형성하고 싶다.',
                  },
                  {
                    text: '향후 배우자 및 가족들과 좋은 관계를 지속적으로 유지하는 것은 앞으로의 내 삶에서 매우 중요한 부분이다.',
                  },
                  {
                    text: '앞으로 배우자 또는 가족과 좋은 관계를 형성하는 데 도움이 되는 상담이나 교육프로그램이 있다면 참여하고 싶다.',
                  },
                  {
                    text: '앞으로 건강을 위한 상담 또는 강좌나 세미나가 열린다면 참여하고 싶다.',
                  },
                ],
              },
            ],
          },

          {
            num: 3,
            name: '사회적 관계',
            qGroups: [
              {
                label: '현재상태',
                average: 3.89,
                stdev: 0.69,
                maxV: 5.00,
                minV: 2,
                startNo: 38,
                questions: [
                  {
                    text: '친목모임에 자주 참여하고 활발히 활동하고 있다.',
                  },
                  {
                    text: '나의 대인관계 능력에는 문제가 없다.(의사소통, 경청, 타인의 감정 배려, 타인의 반응에 대한 적절한 대응, 설득능력 등)',
                  },
                  {
                    text: '친구들과 원만한 관계를 유지하고 있다.',
                  },
                ],
              },
              {
                label: '미래준비도',
                average: 3.87,
                stdev: 0.69,
                maxV: 5.00,
                minV: 2,
                startNo: 41,
                questions: [
                  {
                    text: '사회적 관계나 친목모임을 구축하고 유지하기 위해 노력하고 있다.',
                  },
                  {
                    text: '나는 친구들과 잘 지낼 수 있는 방법을 찾기 위해 노력하고 있다.',
                  },
                  {
                    text: '친구나 이웃과의 관계 개선을 위해 노력하고 있다.',
                  },
                  {
                    text: '대인관계능력의 중요성을 알고 있고 능력을 높이기 위해 노력한다.',
                  },
                ],
              },
              {
                label: '욕구 및 희망',
                average: 4.14,
                stdev: 0.65,
                maxV: 5.00,
                minV: 2,
                startNo: 45,
                questions: [
                  {
                    text: '나는 앞으로도 친구, 이웃과 계속 잘 지내고 싶다.',
                  },
                  {
                    text: '향후 친구, 이웃과 좋은 관계를 유지하고 활발한 사회적 관계를 구축하는 것은 앞으로의 내 인생에서 매우 중요한 일이다.',
                  },
                  {
                    text: '나는 보다 다양한 사회적 네트워크를 구축하고 싶다.',
                  },
                  {
                    text: '앞으로 대인관계능력을 키워주는 상담 또는 교육프로그램이 있다면 참여하고 싶다.',
                  },
                  {
                    text: '앞으로는 만나면 즐거운 사람들과 더욱 긴밀한 관계를 유지하는데 힘쓰고 싶다.',
                  },
                ],
              },
            ],
          },

          {
            num: 4,
            name: '여가',
            qGroups: [
              {
                label: '현재상태',
                average: 3.75,
                stdev: 0.83,
                maxV: 5.00,
                minV: 1,
                startNo: 50,
                questions: [
                  {
                    text: '현재 즐기고 있는 취미가 있다.',
                  },
                  {
                    text: '현재 갖고 있는 여가생활, 레저, 문화생활에 만족한다.',
                  },
                  {
                    text: '배우자, 가족과 함께 하는 취미 또는 여가활동이 있다.',
                  },
                  {
                    text: '일이 바쁘더라도 취미생활을 위해 시간을 내려고 노력하고 있다.',
                  },
                ],
              },
              {
                label: '미래준비도',
                average: 3.96,
                stdev: 0.78,
                maxV: 5.00,
                minV: 1,
                startNo: 54,
                questions: [
                  {
                    text: '취미나 여가생활을 위해 무언가를 배우려고 노력하고 있다.',
                  },
                  {
                    text: '나는 여가시간을 잘 활용하는 방법을 찾기 위해 노력하고 있다.',
                  },
                  {
                    text: '노후나 은퇴 후에도 계속 즐길 수 있는 취미나 여가 활동이 있다.',
                  },
                ],
              },
              {
                label: '욕구 및 희망',
                average: 4.06,
                stdev: 0.65,
                maxV: 5.00,
                minV: 1,
                startNo: 57,
                questions: [
                  {
                    text: '향후 적당한 취미나 여가생활을 갖는 것은 앞으로의 내 인생에서 매우 중요하다.',
                  },
                  {
                    text: '앞으로 나는 일 못지 않게 여가생활을 더 많이 갖고 싶다.',
                  },
                  {
                    text: '만족스런 취미, 여가 생활을 위해서 시간이나 돈을 지금보다 더 과감히 투자하고 싶다.',
                  },
                  {
                    text: '앞으로 새로운 여가, 취미활동을 갖고 싶다.',
                  },
                  {
                    text: '앞으로 취미나 여가생활에 대한 상담 또는 강좌가 있다면 참여하고 싶다.',
                  },
                ],
              },
            ],
          },

          {
            num: 5,
            name: '일과 자기계발',
            qGroups: [
              {
                label: '현재상태',
                average: 3.66,
                stdev: 0.75,
                maxV: 5.00,
                minV: 1,
                startNo: 62,
                questions: [
                  {
                    text: '(직업과 관련하여)현재까지 내가 해왔던 일은 성공적이다.',
                  },
                  {
                    text: '내가 하는 일에 대해 충분한 지식과 능력을 가지고 있다.',
                  },
                  {
                    text: '내가 가진 능력이나 기술 등 나만의 전문적 역량은 경쟁력이 있다.',
                  },
                  {
                    text: '내 삶에서 지금까지 이루어진 자기계발 정도에 만족하고 있다.',
                  },
                ],
              },
              {
                label: '미래준비도',
                average: 3.44,
                stdev: 0.85,
                maxV: 5.00,
                minV: 1,
                startNo: 66,
                questions: [
                  {
                    text: '(현 직장, 다른 직업 어느 쪽이든) 향후 경력 개발을 위한 구체적인 계획이 있다.',
                  },
                  {
                    text: '(현 직장, 다른 직업 어느 쪽이든) 향후 성공적인 경력 개발을 위해 노력하고 있다.',
                  },
                  {
                    text: '자기계발을 통해 나의 능력을 향상시키기 위해 노력하고 있다.',
                  },
                  {
                    text: '이직 / 재취업 / 창업 등에 대비해서 준비하고 있다.',
                  },
                ],
              },
              {
                label: '욕구 및 희망',
                average: 4.04,
                stdev: 0.74,
                maxV: 5.00,
                minV: 1,
                startNo: 70,
                questions: [
                  {
                    text: '나의 경험과 능력을 살릴 수 있는 업종에서 계속 일하고 싶다.',
                  },
                  {
                    text: '앞으로 어떤 분야에서 어떤 능력을 향상시키고 싶은지 구체적으로 알고 있다.',
                  },
                  {
                    text: '앞으로 전문적 역량의 강화나 자기계발을 위한 상담 또는 교육프로그램이 있다면 꼭 참여하고 싶다.',
                  },
                  {
                    text: '향후 자기계발을 통해 능력을 향상시키는 것은 앞으로의 내 삶에서 자아실현과 보람을 위해 매우 중요하다.',
                  },
                ],
              },
            ],
          },

          {
            num: 6,
            name: '사회공헌',
            qGroups: [
              {
                label: '현재상태',
                average: 3.16,
                stdev: 0.96,
                maxV: 5.00,
                minV: 1,
                startNo: 74,
                questions: [
                  {
                    text: '현재 사회공헌활동이나 재능기부활동에 활발히 참여하고 있다.',
                  },
                  {
                    text: '사회참여활동을 할 수 있는 기관, 단체에 대해 잘 알고 있다.',
                  },
                  {
                    text: '현재 기회가 될 때마다 도움이 필요한 곳에 도움을 주고 있다.(이웃, 기관 등)',
                  },
                ],
              },
              {
                label: '미래준비도',
                average: 3.36,
                stdev: 0.89,
                maxV: 5.00,
                minV: 1,
                startNo: 77,
                questions: [
                  {
                    text: '보다 활발한 기부와 나눔의 삶을 위해 준비하고 있다.',
                  },
                  {
                    text: '효과적인 사회봉사에 필요한 능력을 키우기 위해 노력하고 있다.',
                  },
                  {
                    text: '사회공헌을 할 수 있는 장소나 방법을 알아보기 위해 노력하고 있다.',
                  },
                ],
              },
              {
                label: '욕구 및 희망',
                average: 3.36,
                stdev: 0.78,
                maxV: 5.00,
                minV: 1,
                startNo: 80,
                questions: [
                  {
                    text: '향후 여건이 허락된다면 꼭 사회공헌활동을 하고 싶다.',
                  },
                  {
                    text: '앞으로도 내 능력을 나눌 수 있는 일거리가 있다면 적은 보수라도 기꺼이 참여하고 싶다.',
                  },
                  {
                    text: '앞으로 내 능력을 나눌 수 있는 일거리를 연결해주는 프로그램이 있다면 지속적으로 참가하고 싶다.',
                  },
                  {
                    text: '향후 다른 사람을 돕고 사회에 공헌하는 것은 앞으로의 내 삶에서 자아실현과 보람을 위해 매우 중요하다.',
                  },
                ],
              },
            ],
          },
        ],
      };
    },
    methods: {
      gradeClass(gradeKo) {
        if (gradeKo === '높음') {
          return 'high';
        } else if (gradeKo === '낮음') {
          return 'low';
        }
        return 'normal';
      },
      arrowClass(gradeKo) {
        if (gradeKo === '높음') {
          return 'fa-arrow-up';
        } else if (gradeKo === '낮음') {
          return 'fa-arrow-down';
        }
        return 'fa-minus';
      },
      tabClick(step, nextStep) {
        const questionsStart = [];
        const tabCount = this.tabs.length;
        this.stepTitleNo = nextStep;
        for (let i = 0; i < tabCount; i += 1) {
          const smallArr = [];
          for (let j = 0; j < 3; j += 1) {
            if (i > 0 && j === 0) {
              questionsStart[i - 1].push(this.tabs[i].qGroups[j].startNo);
            }
            smallArr.push(this.tabs[i].qGroups[j].startNo);
            if (i === tabCount - 1 && j === 2) {
              smallArr.push(84);
            }
          }
          questionsStart.push(smallArr);
        }
        let answerComplate = true;
        if (this.currentTabChecking && this.currentTab === 7) {
          for (let i = 84; i < 93; i += 1) {
            if (!this.answer.answers[i]) {
              alert('답변을 모두 작성해주세요.');
              answerComplate = false;
              break;
            }
          }
        } else if (this.currentTabChecking) {
          for (let i = questionsStart[this.currentTab][0];
            i < questionsStart[this.currentTab][3];
            i += 1) {
            if (!this.answer.answers[i]) {
              alert('답변을 모두 작성해주세요.');
              answerComplate = false;
              break;
            }
          }
        }
        if (answerComplate) {
          if (this.currentTabChecking && this.currentTab !== 7) {
            const partResult = [];
            partResult.push(this.currentTab); // 스탭 [0]
            partResult.push(this.tabs[this.currentTab].name); // 단계 이름 [1]
            for (let i = 0; i < 3; i += 1) {
              const targetVal = this.tabs[this.currentTab].qGroups[i].average;
              partResult.push(targetVal); // 비교 값
              const questionCount = questionsStart[this.currentTab][i + 1]
                - questionsStart[this.currentTab][i];
              let answerSum = 0;
              for (let j = questionsStart[this.currentTab][i];
                j < questionsStart[this.currentTab][i + 1];
                j += 1) {
                answerSum += this.answer.answers[j];
              }
              const averageVal = (answerSum / questionCount).toFixed(2);
              partResult.push(averageVal); // 결과 값
              let resultText = '보통';
              if (averageVal > targetVal + 0.3) {
                resultText = '높음';
              } else if (averageVal < targetVal - 0.5) {
                resultText = '낮음';
              }
              partResult.push(resultText); // 해석 값
            }
            this.calculResult.push(partResult);
            this.checkingSteps.push(this.currentTab);
          }
          this.currentTabChecking = false;
          this.showFinish = false;
          if (nextStep !== 7) {
            const tab = `#tabListId${nextStep}`;
            const tabPane = `#tabList${nextStep}`;
            const writeBtn = `#writebtn${nextStep}`;
            $('.btn-tab').removeClass('active');
            $('.btn-tab-pane').removeClass('active');
            $(tab).addClass('active');
            $(tabPane).addClass('active');
            $(writeBtn).focus();
          } else if (this.checkingSteps.length !== 0 && nextStep === 7) {
            $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
            this.currentTab = 7;
            this.currentTabChecking = true;
            $('.btn-tab').removeClass('active');
            $('.btn-tab-pane').removeClass('active');
            this.showFinish = true;
            const button = '#session-btn-7';
            const bgGroup = '#top-decor-gb-group-7';
            const radioClass = '#radio-value-label-group--7';
            const boxClass = '.diagnosis-box-ul--7';
            $(button).hide();
            $(bgGroup).show();
            $(radioClass).show();
            $(boxClass).show();
          } else if (this.checkingSteps.length === 0 && nextStep === 7) {
            alert('최소한 하나의 영역에 대한 설문을 작성해주세요.');
          }
        }
      },
      answering(order, value) {
        this.answer.answers[order] = Number(value);
      },
      doAnswer(step) {
        $('html, body').animate({ scrollTop: `${$('#buttons-tab').offset().top}px` }, 'fast');
        this.currentTab = step;
        this.currentTabChecking = true;
        const button = `#session-btn-${step}`;
        const bgGroup = `#top-decor-gb-group-${step}`;
        const radioClass = `#radio-value-label-group--${step}`;
        const boxClass = `.diagnosis-box-ul--${step}`;
        $(button).hide();
        $(bgGroup).show();
        $(radioClass).show();
        $(boxClass).show();
      },
      blankAnswers() {
        const answerArray = [];
        for (let i = 0; i < 93; i += 1) {
          answerArray.push(null);
        }
        this.answer = { gender: '', age: '', job: '', answers: answerArray };
      },
      answerGender(value) {
        this.answer.gender = value;
      },
      answerAge() {
        this.answer.age = Number(this.age);
        if (Number(this.age) > 100 || Number(this.age) < 0) {
          alert('나이를 확인해주세요.');
          $('#age').focus();
        }
      },
      answerJob(value) {
        this.answer.job = value;
      },
      submitAnswers() {
        let answerComplate = true;
        for (let i = 84; i < 93; i += 1) {
          if (!this.answer.answers[i]) {
            alert('답변을 모두 작성해주세요.');
            answerComplate = false;
            break;
          }
        }
        if (answerComplate) {
          if (!this.answer.job || !this.answer.age || !this.answer.gender) {
            alert('기본정보를 입력해주세요.');
          } else if (Number(this.answer.age) > 100 || Number(this.answer.age) < 0) {
            alert('나이를 확인해주세요.');
            $('#age').focus();
          } else {
            axios.post('/api/diagnosis', this.answer).then(() => {
              alert('등록되었습니다.');
              this.showResult = true;
            }).catch((error) => {
              alert(error.data.msg);
            });
          }
        }
      },
    },
    mounted() {
      this.blankAnswers();
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// SelfDiagnosis.vue?4a1bc056